//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"ApplicationData",0,"Features.UserDefinedFeatureApplicationData",0],[0,"ClassName",0,0]],[[["numComponents"],"GetComponentFeature",{R_:{components:"Features.Feature[]"}},0,0],[["numExpressions"],"GetExpressionData",{R_:{expressions:"Features.UserDefinedFeatureExpressionData[]"}},0,0],[["numReferences"],"GetReferenceData",{R_:{references:"Features.UserDefinedFeatureReferenceData[]"}},0,0],[["additionalFeatures"],"AddAdditionalFeaturesToDeleteOrSuppress",{},1,0]],[]];
SPLM.Features.UserDefinedFeatureDeleteOrSuppressEvent = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.UserDefinedFeatureDeleteOrSuppressEvent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;